export default "__VITE_ASSET__DmQTDX8y__"